import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { EnumPaymentType } from "@/api/cashier";

export const useStaticOptions = () => {
  const { t } = useTranslation();

  const transactionOptions = useMemo(
    () => [
      { label: t("transactions.history.filterOptions.all"), value: "all" },
      {
        label: t("transactions.history.filterOptions.transactions.deposit"),
        value: EnumPaymentType.EnumPaymentTypeDeposit,
      },
      {
        label: t("transactions.history.filterOptions.transactions.withdraw"),
        value: EnumPaymentType.EnumPaymentTypeWithdrawal,
      },
      {
        label: t(
          "transactions.history.filterOptions.transactions.internalTransfer"
        ),
        value: EnumPaymentType.EnumPaymentTypeTransfer,
      },
      {
        label: t(
          "transactions.history.filterOptions.transactions.cashAdjustment"
        ),
        value: EnumPaymentType.EnumPaymentTypeCashAdjustment,
      },
    ],
    [t]
  );

  const timeOptions = useMemo(
    () => [
      { label: t("transactions.history.filterOptions.all"), value: "all" },
      {
        label: t("transactions.history.filterOptions.time.today"),
        value: "today",
      },
      {
        label: t("transactions.history.filterOptions.time.thisWeek"),
        value: "thisWeek",
      },
      {
        label: t("transactions.history.filterOptions.time.thisMonth"),
        value: "thisMonth",
      },
      {
        label: t("transactions.history.filterOptions.time.thisYear"),
        value: "thisYear",
      },
    ],
    [t]
  );

  const statusOptions = useMemo(
    () => [
      { label: t("transactions.history.filterOptions.all"), value: "all" },
      { label: t("transactions.history.status.requested"), value: "requested" },
      { label: t("transactions.history.status.pending"), value: "pending" },
      {
        label: t("transactions.history.status.processing"),
        value: "processing",
      },
      { label: t("transactions.history.status.complete"), value: "complete" },
      {
        label: t("transactions.history.status.unsuccessful"),
        value: "unsuccessful",
      },
      { label: t("transactions.history.status.cancelled"), value: "cancelled" },
    ],
    [t]
  );

  return {
    transactionOptions,
    timeOptions,
    statusOptions,
  };
};
